import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ─── PWA service worker registration ──────────────────────────────────────
// The prior SW (`ispeed-v1`) was too aggressive — it cached hashed JS
// bundles under a stable name, which meant returning visitors ran the
// OLD bundle for days after any deploy. That's what broke the Property
// Type dropdown on production. Fix: bump the cache name in
// `service-worker.js` AND stop caching hashed static assets.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      // Force a check for a new SW every time the tab loads. Without
      // this, browsers can stick on an old SW for 24h.
      try { reg.update(); } catch { /* ignore */ }
    }).catch(() => {
      // Silent — registration failures shouldn't break the app.
    });

    // ── Listen for SW_UPDATED postMessage from the new SW's activate.
    // When it arrives we know the JS bundle has changed since the tab
    // was opened. Show a lightweight "Update ready" chip so the user
    // can refresh without losing form state at their own pace.
    navigator.serviceWorker.addEventListener("message", (evt) => {
      if (evt?.data?.type !== "SW_UPDATED") return;
      showUpdateReadyChip();
    });
  });
}

/** Tiny non-blocking update chip. Zero React dependency so it works
 *  even if App has crashed for some reason. */
function showUpdateReadyChip() {
  if (document.getElementById("__ispeed_update_chip")) return;
  const chip = document.createElement("div");
  chip.id = "__ispeed_update_chip";
  chip.setAttribute("data-testid", "app-update-ready-chip");
  chip.innerHTML = `
    <div style="display:flex;align-items:center;gap:12px;">
      <span style="font-weight:800;letter-spacing:0.02em;">New version ready</span>
      <button id="__ispeed_update_chip_btn" style="background:#111827;color:#fff;border:none;padding:6px 12px;border-radius:6px;font-weight:700;cursor:pointer;font-size:12px;">Refresh</button>
    </div>`;
  Object.assign(chip.style, {
    position: "fixed", bottom: "20px", right: "20px", zIndex: 99999,
    background: "linear-gradient(135deg,#FDE68A 0%,#FBBF24 100%)",
    color: "#78350F", padding: "10px 14px", borderRadius: "12px",
    boxShadow: "0 12px 30px rgba(0,0,0,0.18)", fontFamily: "system-ui,-apple-system,sans-serif",
    fontSize: "13px", border: "1px solid #F59E0B",
  });
  document.body.appendChild(chip);
  document.getElementById("__ispeed_update_chip_btn")?.addEventListener("click", () => {
    window.location.reload();
  });
}
